<template>
    <div class="volunteer">
        <a-card class="eld" title="All Volunteer">
            <a-table style="width: 100%" :loading="loading" rowKey="uid" :columns="columns" :data-source="volunteerList || []">
                <span slot="age" slot-scope="age">{{ GetAgeFromBirth(age) }}</span>
                <span slot="status" slot-scope="status">
                    <a-tag v-if="status" color="#87d068">Matched</a-tag>
                    <a-tag v-else color="#f50">UnMatched</a-tag>
                </span>
                <span slot="date" slot-scope="date">{{ formatter(date) }}</span>
                <span slot="action" slot-scope="id">
                    <a-button @click="detail(id)">Check Detail</a-button>
                </span>
            </a-table>
        </a-card>
    </div>
</template>
  
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import dayjs from "dayjs";
const columns = [
    {
        dataIndex: "username",
        key: "username",
        title: "Name",
    },
    {
        dataIndex: "birthday",
        key: "age",
        title: "Age",
        scopedSlots: { customRender: "age" },
    },
    {
        dataIndex: "matched",
        key: "status",
        title: "Status",
        scopedSlots: { customRender: "status" },
        filters: [
            { text: "Matched Elder", value: "1" },
            { text: "Unmatched Elder", value: "0" },
        ],
        filterMultiple: false,
        onFilter: (value, record) =>
            value === "1" ? record.matched : !record.matched,
    },
    {
        dataIndex: "createdAt",
        key: "createdAt",
        title: "Issue Date",
        scopedSlots: { customRender: "date" },
        sorter: (a, b) => dayjs(a.createdAt).diff(dayjs(b.createdAt)),
    },
    {
        dataIndex: "uid",
        key: "uid",
        title: "Action",
        scopedSlots: { customRender: "action" },
    },
];

export default {
    data() {
        return {
            columns,
            error: null,
        };
    },
    computed: {
        ...mapState({
            loading: "admin/loading",
        }),
        ...mapGetters({
            volunteerList: "admin/volunList",
        }),
    },
    methods: {
        formatter(time) {
            return dayjs(time).format("YYYY/MM/DD");
        },
        GetAgeFromBirth(birth) {
            return dayjs().year() - Number(birth)
        },
        ...mapActions({
            getElderList: "admin/getElderList",
            getVolunteerList: "admin/getVolunteerList",
            getWaitList: "admin/getWaitList",
        }),
        ...mapMutations({
            setCurVolun: "admin/setCurVolun",
        }),
        async detail(id) {
            const cur = this.volunteerList.find((item) => item.uid === id);
            this.setCurVolun(cur);
            this.$router.push(`/admin/volunteer/${cur.username}`);
        },
    },
    async mounted() {

        if (!this.volunteerList) {
            await this.getVolunteerList();
        }

        // if (!this.waitVolunteers) {
        //   await this.getWaitList()
        // }
    },
};
</script>
  
<style lang="less" scoped>
.volunteer {
    width: 100%;
    padding: 2vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .top {
        width: 100%;
        margin-bottom: 2vw;
        display: flex;
        flex-direction: row;
    }

    .eld {
        width: 100%;
        min-height: 50vh;
    }
}
</style>